import { render } from "./ImpactRoundedImg.vue?vue&type=template&id=5066a4ac"
import script from "./ImpactRoundedImg.vue?vue&type=script&lang=js"
export * from "./ImpactRoundedImg.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__